import googleImage from "@/assets/images/google-logo-full.png";
import { cn } from "@/common/utils/css.utils";
import Image from "@/components/common/Image";
import { useContentLocale } from "@/i18n/hooks";
import GoogleReviewsPreval from "@/scenes/auth/register/preval/GoogleReviews.preval";
import Rating from "@/ui/Rating";

type GoogleReviewRatingProps = {
  size?: "small" | "large";
};

const SIZE_MAP: Record<NonNullable<GoogleReviewRatingProps["size"]>, string> = {
  small: "h-[22px] md:w-[70px]",
  large: "h-[30px] w-[70px] md:h-[30px] md:w-[80px]",
};

export const GoogleReviewRating = ({
  size = "small",
}: GoogleReviewRatingProps) => {
  const locale = useContentLocale();
  const { rating } = GoogleReviewsPreval[locale];

  return (
    <span className="flex items-center gap-x-2">
      <span className={cn("relative ", SIZE_MAP[size])}>
        <Image
          layout="fill"
          objectFit="contain"
          src={googleImage}
          alt="google logo"
        />
      </span>
      <span className="flex">
        <Rating value={rating} className="h-5 w-5" />
      </span>
    </span>
  );
};
